// ── Config ────────────────────────────────────────────────────────────────
  const SD_SUPABASE_URL     = 'https://sfatrzmeapcuszpxnrvc.supabase.co';
  const SD_SUPABASE_ANON    = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNmYXRyem1lYXBjdXN6cHhucnZjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzczNDAwMzIsImV4cCI6MjA5MjkxNjAzMn0.kWZtOlD1-S6f830_4uPrktEVvxe88rWTTUEk4-Mewds';
  const SD_THEMES_JSON_URL  = 'https://pandatests.myshopify.com/cdn/shop/t/40/assets/themes.json';
  const SD_APPS_JSON_URL    = 'https://pandatests.myshopify.com/cdn/shop/t/70/assets/apps.json';
  const SD_THEME_UTM_SOURCE = 'ezfycode.com';
  const SD_CHROME_EXTENSION_URL = 'https://chromewebstore.google.com/detail/placeholder';
  const SD_PAGE_SIZE        = 150;
  const SD_FETCH_CHUNK_SIZE = 1000;
  const SD_RETRY_DELAY_MS   = 2500;
  const SD_CACHE_KEY        = 'all-shopify-stores-cache-v4';
  const SD_IDB_NAME         = 'all-shopify-stores-db';
  const SD_IDB_STORE        = 'cache';
  const SD_COLUMNS          = [{"key": "id", "label": "ID"}, {"key": "url", "label": "URL"}, {"key": "theme_name", "label": "Theme Name"}, {"key": "theme_renamed", "label": "Theme Renamed"}, {"key": "theme_version", "label": "Theme Version"}, {"key": "domain", "label": "Website"}, {"key": "currency", "label": "Currency"}, {"key": "product_url", "label": "Product URL"}, {"key": "blog_url", "label": "Has blog"}, {"key": "total_products", "label": "Total Products"}, {"key": "product_names", "label": "Product Names"}, {"key": "product_types", "label": "Product Types"}, {"key": "tags", "label": "Tags"}, {"key": "avg_images_per_product", "label": "Avg Images Per Product"}, {"key": "known_apps", "label": "Apps"}, {"key": "total_apps", "label": "Total apps"}, {"key": "known_categories", "label": "Known Categories"}, {"key": "total_known", "label": "Total Known"}, {"key": "total_unknown", "label": "Total Unknown"}, {"key": "total_head_scripts", "label": "Total Head Scripts"}, {"key": "total_body_scripts", "label": "Total Body Scripts"}, {"key": "total_scripts", "label": "Total Scripts"}, {"key": "total_stylesheets", "label": "Total Stylesheets"}, {"key": "section_store_count", "label": "Section Store Count"}, {"key": "all_external_scripts", "label": "All External Scripts"}, {"key": "known_libraries", "label": "Known Libraries"}, {"key": "total_libraries", "label": "Total Libraries"}, {"key": "theme_status", "label": "Theme Status"}, {"key": "apps_status", "label": "Apps Status"}, {"key": "theme_scraped_at", "label": "Theme Scraped At"}, {"key": "apps_scraped_at", "label": "Apps Scraped At"}, {"key": "psi_status", "label": "PSI Status"}, {"key": "psi_scraped_at", "label": "PSI Scraped At"}, {"key": "last_product_updated", "label": "Last Product Updated"}, {"key": "last_updated_at", "label": "Last Updated At"}, {"key": "theme", "label": "Theme"}, {"key": "status", "label": "Status"}, {"key": "error_message", "label": "Error Message"}, {"key": "mobile_score_home", "label": "Mobile Score Home"}, {"key": "desktop_score_home", "label": "Desktop Score Home"}, {"key": "mobile_score_product", "label": "Mobile Score Product"}, {"key": "desktop_score_product", "label": "Desktop Score Product"}, {"key": "fcp_mobile_home", "label": "FCP Mobile Home"}, {"key": "lcp_mobile_home", "label": "LCP Mobile Home"}, {"key": "tbt_mobile_home", "label": "TBT Mobile Home"}, {"key": "cls_mobile_home", "label": "CLS Mobile Home"}, {"key": "si_mobile_home", "label": "SI Mobile Home"}, {"key": "tti_mobile_home", "label": "TTI Mobile Home"}, {"key": "total_page_size_kb_mobile_home", "label": "Page Size (KB) Mobile Home"}, {"key": "num_requests_mobile_home", "label": "Requests Mobile Home"}, {"key": "ttfb_ms_mobile_home", "label": "TTFB ms Mobile Home"}, {"key": "fcp_desktop_home", "label": "FCP Desktop Home"}, {"key": "lcp_desktop_home", "label": "LCP Desktop Home"}, {"key": "tbt_desktop_home", "label": "TBT Desktop Home"}, {"key": "cls_desktop_home", "label": "CLS Desktop Home"}, {"key": "si_desktop_home", "label": "SI Desktop Home"}, {"key": "tti_desktop_home", "label": "TTI Desktop Home"}, {"key": "total_page_size_kb_desktop_home", "label": "Page Size (KB) Desktop Home"}, {"key": "num_requests_desktop_home", "label": "Requests Desktop Home"}, {"key": "ttfb_ms_desktop_home", "label": "TTFB ms Desktop Home"}, {"key": "fcp_mobile_product", "label": "FCP Mobile Product"}, {"key": "lcp_mobile_product", "label": "LCP Mobile Product"}, {"key": "tbt_mobile_product", "label": "TBT Mobile Product"}, {"key": "cls_mobile_product", "label": "CLS Mobile Product"}, {"key": "si_mobile_product", "label": "SI Mobile Product"}, {"key": "tti_mobile_product", "label": "TTI Mobile Product"}, {"key": "total_page_size_kb_mobile_product", "label": "Page Size (KB) Mobile Product"}, {"key": "num_requests_mobile_product", "label": "Requests Mobile Product"}, {"key": "ttfb_ms_mobile_product", "label": "TTFB ms Mobile Product"}, {"key": "fcp_desktop_product", "label": "FCP Desktop Product"}, {"key": "lcp_desktop_product", "label": "LCP Desktop Product"}, {"key": "tbt_desktop_product", "label": "TBT Desktop Product"}, {"key": "cls_desktop_product", "label": "CLS Desktop Product"}, {"key": "si_desktop_product", "label": "SI Desktop Product"}, {"key": "tti_desktop_product", "label": "TTI Desktop Product"}, {"key": "total_page_size_kb_desktop_product", "label": "Page Size (KB) Desktop Product"}, {"key": "num_requests_desktop_product", "label": "Requests Desktop Product"}, {"key": "ttfb_ms_desktop_product", "label": "TTFB ms Desktop Product"}, {"key": "report_url_home_mobile", "label": "Report URL Home Mobile"}, {"key": "report_url_home_desktop", "label": "Report URL Home Desktop"}, {"key": "report_url_product_mobile", "label": "Report URL Product Mobile"}, {"key": "report_url_product_desktop", "label": "Report URL Product Desktop"}, {"key": "sub_niche", "label": "Sub Niche"}, {"key": "niche", "label": "Niche"}, {"key": "estimated_visits_and_income", "label": "Traffic & Value"}, {"key": "niche_scraped_at", "label": "Niche Scraped At"}];
  const SD_VISIBLE_COLUMNS  = ["theme", "domain", "currency", "blog_url", "known_apps", "mobile_score_home", "mobile_score_product", "niche", "sub_niche", "estimated_visits_and_income"];
  const SD_SELECT_COLUMNS   = ["theme", "domain", "currency", "blog_url", "known_apps", "mobile_score_home", "mobile_score_product", "niche", "sub_niche"];
  const SD_COLUMN_LABELS    = {"id": "ID", "url": "URL", "theme_name": "Theme Name", "theme_renamed": "Theme Renamed", "theme_version": "Theme Version", "domain": "Website", "currency": "Currency", "product_url": "Product URL", "blog_url": "Has blog", "total_products": "Total Products", "product_names": "Product Names", "product_types": "Product Types", "tags": "Tags", "avg_images_per_product": "Avg Images Per Product", "known_apps": "Apps", "total_apps": "Total apps", "known_categories": "Known Categories", "total_known": "Total Known", "total_unknown": "Total Unknown", "total_head_scripts": "Total Head Scripts", "total_body_scripts": "Total Body Scripts", "total_scripts": "Total Scripts", "total_stylesheets": "Total Stylesheets", "section_store_count": "Section Store Count", "all_external_scripts": "All External Scripts", "known_libraries": "Known Libraries", "total_libraries": "Total Libraries", "theme_status": "Theme Status", "apps_status": "Apps Status", "theme_scraped_at": "Theme Scraped At", "apps_scraped_at": "Apps Scraped At", "psi_status": "PSI Status", "psi_scraped_at": "PSI Scraped At", "last_product_updated": "Last Product Updated", "last_updated_at": "Last Updated At", "theme": "Theme", "status": "Status", "error_message": "Error Message", "mobile_score_home": "Mobile Score Home", "desktop_score_home": "Desktop Score Home", "mobile_score_product": "Mobile Score Product", "desktop_score_product": "Desktop Score Product", "fcp_mobile_home": "FCP Mobile Home", "lcp_mobile_home": "LCP Mobile Home", "tbt_mobile_home": "TBT Mobile Home", "cls_mobile_home": "CLS Mobile Home", "si_mobile_home": "SI Mobile Home", "tti_mobile_home": "TTI Mobile Home", "total_page_size_kb_mobile_home": "Page Size (KB) Mobile Home", "num_requests_mobile_home": "Requests Mobile Home", "ttfb_ms_mobile_home": "TTFB ms Mobile Home", "fcp_desktop_home": "FCP Desktop Home", "lcp_desktop_home": "LCP Desktop Home", "tbt_desktop_home": "TBT Desktop Home", "cls_desktop_home": "CLS Desktop Home", "si_desktop_home": "SI Desktop Home", "tti_desktop_home": "TTI Desktop Home", "total_page_size_kb_desktop_home": "Page Size (KB) Desktop Home", "num_requests_desktop_home": "Requests Desktop Home", "ttfb_ms_desktop_home": "TTFB ms Desktop Home", "fcp_mobile_product": "FCP Mobile Product", "lcp_mobile_product": "LCP Mobile Product", "tbt_mobile_product": "TBT Mobile Product", "cls_mobile_product": "CLS Mobile Product", "si_mobile_product": "SI Mobile Product", "tti_mobile_product": "TTI Mobile Product", "total_page_size_kb_mobile_product": "Page Size (KB) Mobile Product", "num_requests_mobile_product": "Requests Mobile Product", "ttfb_ms_mobile_product": "TTFB ms Mobile Product", "fcp_desktop_product": "FCP Desktop Product", "lcp_desktop_product": "LCP Desktop Product", "tbt_desktop_product": "TBT Desktop Product", "cls_desktop_product": "CLS Desktop Product", "si_desktop_product": "SI Desktop Product", "tti_desktop_product": "TTI Desktop Product", "total_page_size_kb_desktop_product": "Page Size (KB) Desktop Product", "num_requests_desktop_product": "Requests Desktop Product", "ttfb_ms_desktop_product": "TTFB ms Desktop Product", "report_url_home_mobile": "Report URL Home Mobile", "report_url_home_desktop": "Report URL Home Desktop", "report_url_product_mobile": "Report URL Product Mobile", "report_url_product_desktop": "Report URL Product Desktop", "sub_niche": "Sub Niche", "niche": "Niche", "estimated_visits_and_income": "Traffic & Value", "niche_scraped_at": "Niche Scraped At"};

  const sdStore = {
    rows: [],
    totalCount: 0,
    fullyLoaded: false
  };
  let sdFilteredRows = [];
  const sdFilters = { q: '', niche: '', subNiches: [], themes: [], apps: '' };
  let sdCurrentRowsView = [];

  function sdOpenIdb() {
    return new Promise((resolve, reject) => {
      if (!window.indexedDB) {
        reject(new Error('IndexedDB unavailable'));
        return;
      }
      const req = window.indexedDB.open(SD_IDB_NAME, 1);
      req.onupgradeneeded = () => {
        const db = req.result;
        if (!db.objectStoreNames.contains(SD_IDB_STORE)) db.createObjectStore(SD_IDB_STORE);
      };
      req.onsuccess = () => resolve(req.result);
      req.onerror = () => reject(req.error || new Error('Failed opening IndexedDB'));
    });
  }

  async function sdReadIdbCache() {
    try {
      const db = await sdOpenIdb();
      const tx = db.transaction(SD_IDB_STORE, 'readonly');
      const store = tx.objectStore(SD_IDB_STORE);
      const req = store.get(SD_CACHE_KEY);
      const value = await new Promise((resolve, reject) => {
        req.onsuccess = () => resolve(req.result || null);
        req.onerror = () => reject(req.error);
      });
      db.close();
      return value;
    } catch (e) {
      return null;
    }
  }

  async function sdWriteIdbCache(payload) {
    try {
      const db = await sdOpenIdb();
      const tx = db.transaction(SD_IDB_STORE, 'readwrite');
      tx.objectStore(SD_IDB_STORE).put(payload, SD_CACHE_KEY);
      await new Promise((resolve, reject) => {
        tx.oncomplete = resolve;
        tx.onerror = () => reject(tx.error);
      });
      db.close();
    } catch (e) {
      console.warn('Could not persist IndexedDB cache', e);
    }
  }

  async function sdTryStoreCache() {
    if (!sdStore.fullyLoaded) return;
    const payload = {
      savedAt: Date.now(),
      rows: sdStore.rows,
      totalCount: sdStore.totalCount
    };
    try { localStorage.setItem(SD_CACHE_KEY, JSON.stringify(payload)); } catch (e) {}
    await sdWriteIdbCache(payload);
  }


  let sdCurrentPage = 1;
  let sdLeftPage1Once = false;
  let sdThemesByName = {};
  let sdAppsByTitle = {};

  function sdSleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  function sdFormatLink(value) {
    if (value === null || value === undefined || value === '-') return '-';
    const str = String(value);
    const href = str.startsWith('http://') || str.startsWith('https://') ? str : `https://${str}`;
    return `<a href="${href}" target="_blank" rel="noopener">${str}</a>`;
  }

  function sdNormalizeThemeName(value) {
    return String(value || '').trim().toLowerCase().replace(/[^a-z0-9]/g, '');
  }

  function sdAppendThemeUtm(url) {
    if (!url || url === '-') return '-';
    try {
      const parsed = new URL(url);
      parsed.searchParams.set('utm_source', SD_THEME_UTM_SOURCE);
      return parsed.toString();
    } catch (e) {
      return url;
    }
  }

  function sdFormatApps(value) {
    if (value === null || value === undefined || value === '') return '-';
    if (Array.isArray(value)) {
      return value.length ? value.map(v => String(v)).join(', ') : '-';
    }
    const str = String(value).trim();
    if (!str) return '-';
    try {
      const parsed = JSON.parse(str);
      if (Array.isArray(parsed)) {
        return parsed.length ? parsed.map(v => String(v)).join(', ') : '-';
      }
    } catch (e) {}
    return str;
  }

  function sdSplitApps(value) {
    const formatted = sdFormatApps(value);
    if (formatted === '-') return [];
    return formatted
      .split(',')
      .map(item => item.trim())
      .filter(Boolean);
  }

  async function sdFetchThemes() {
    const res = await fetch(SD_THEMES_JSON_URL);
    if (!res.ok) {
      throw new Error(`Theme JSON request failed with ${res.status}`);
    }

    const payload = await res.json();
    const themes = {};
    const items = Array.isArray(payload) ? payload : Object.values(payload || {});
    items.forEach((item) => {
      if (!item || typeof item !== 'object') return;
      const title = item.title || item.themeName || item.theme || item.name || '';
      const themeUrl = item.themeUrl || item.themeURL || item.url || '';
      const normalized = sdNormalizeThemeName(title);
      if (normalized && themeUrl) themes[normalized] = { title, themeUrl };
    });

    sdThemesByName = themes;
  }

  async function sdFetchApps() {
    const res = await fetch(SD_APPS_JSON_URL);
    if (!res.ok) {
      throw new Error(`Apps JSON request failed with ${res.status}`);
    }

    const payload = await res.json();
    const apps = {};

    (payload || []).forEach(app => {
      const title = sdNormalizeThemeName(app?.appTitle);
      if (title && app?.sourceAppUrl) {
        apps[title] = app.sourceAppUrl;
      }
    });

    sdAppsByTitle = apps;
  }

  async function sdFetchTotalCount() {
    const res = await fetch(
      `${SD_SUPABASE_URL}/rest/v1/stores?select=id&limit=1`,
      {
        headers: {
          apikey: SD_SUPABASE_ANON,
          Authorization: `Bearer ${SD_SUPABASE_ANON}`,
          Prefer: 'count=exact'
        }
      }
    );

    if (!res.ok) {
      throw new Error(`Supabase count request failed with ${res.status}`);
    }

    const contentRange = res.headers.get('content-range') || '';
    const total = parseInt(contentRange.split('/')[1] || '0', 10);
    sdStore.totalCount = Number.isNaN(total) ? 0 : total;
  }

  async function sdFetchTotalCountWithRetry() {
    while (true) {
      try {
        await sdFetchTotalCount();
        return sdStore.totalCount;
      } catch (error) {
        console.warn('Total count fetch failed. Retrying...', error);
        await sdSleep(SD_RETRY_DELAY_MS);
      }
    }
  }

  function sdParseStaticRows() {
    const rowEls = document.querySelectorAll('#sd-table-body tr[data-static]');
    sdStore.rows = Array.from(rowEls).map(tr => {
      const obj = {};
      SD_VISIBLE_COLUMNS.forEach((key, i) => {
        const td = tr.cells[i];
        let v;
        if (td) {
          if (td.hasAttribute('data-sd-value')) {
            v = td.getAttribute('data-sd-value');
            const keepEmpty = key === 'blog_url' || key === 'estimated_visits_and_income' || key === 'theme' || key === 'domain';
            if (!keepEmpty && (v === null || v === '')) v = '-';
          } else {
            v = td.textContent.trim() || '-';
          }
        } else {
          v = '-';
        }
        obj[key] = v;
      });
      return obj;
    });
  }

  function sdPaginationItems(totalPages, current) {
    if (totalPages <= 7) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }
    const set = new Set();
    for (let p = 1; p <= Math.min(3, totalPages); p += 1) set.add(p);
    for (let p = Math.max(1, totalPages - 2); p <= totalPages; p += 1) set.add(p);
    for (let p = Math.max(1, current - 2); p <= Math.min(totalPages, current + 2); p += 1) set.add(p);
    const sorted = [...set].sort((a, b) => a - b);
    const out = [];
    let prev = null;
    sorted.forEach(p => {
      if (prev !== null && p - prev > 1) out.push(null);
      out.push(p);
      prev = p;
    });
    return out;
  }

  function sdHasAnyFilter() {
    return !!(
      sdFilters.q.trim() ||
      sdFilters.niche.trim() ||
      sdFilters.subNiches.length ||
      sdFilters.themes.length ||
      sdFilters.apps.trim()
    );
  }

  function sdRowsForView() {
    return sdFilteredRows.length || sdHasAnyFilter() ? sdFilteredRows : sdStore.rows;
  }

  function sdUnlockPaginationButtons() {
    const rowsView = sdRowsForView();
    document.querySelectorAll('[data-page]').forEach(btn => {
      const page = parseInt(btn.getAttribute('data-page'), 10);
      const endRow = Math.min(page * SD_PAGE_SIZE, rowsView.length);
      const isAvailable = rowsView.length >= endRow;
      if (isAvailable && btn.classList.contains('EzfyAllStores__page-btn--skeleton')) {
        btn.classList.remove('EzfyAllStores__page-btn--skeleton');
        btn.disabled = false;
      }
    });

    sdUpdatePaginationVisual();
  }

  function sdUpdatePaginationVisual() {
    const rowsView = sdRowsForView();
    const totalRows = rowsView.length;
    const totalPages = Math.max(1, Math.ceil(totalRows / SD_PAGE_SIZE));

    document.querySelectorAll('[data-page]').forEach(btn => {
      const page = parseInt(btn.getAttribute('data-page'), 10);
      const endRow = Math.min(page * SD_PAGE_SIZE, totalRows);
      const available = rowsView.length >= endRow;

      btn.classList.toggle('EzfyAllStores__page-btn--active', page === sdCurrentPage);
      if (page > 1 && !available) {
        btn.classList.add('EzfyAllStores__page-btn--skeleton');
      } else {
        btn.classList.remove('EzfyAllStores__page-btn--skeleton');
      }

      btn.disabled = page === sdCurrentPage || !available;
    });

    document.querySelectorAll('[data-nav="prev"]').forEach(b => {
      const dis = sdCurrentPage <= 1;
      b.disabled = dis;
      b.classList.toggle('EzfyAllStores__page-btn--disabled', dis);
    });

    document.querySelectorAll('[data-nav="next"]').forEach(b => {
      const next = sdCurrentPage + 1;
      const can =
        next <= totalPages &&
        rowsView.length >= Math.min(next * SD_PAGE_SIZE, totalRows);
      b.disabled = !can;
      b.classList.toggle('EzfyAllStores__page-btn--disabled', !can);
    });

    const startRow = (sdCurrentPage - 1) * SD_PAGE_SIZE + 1;
    const endRow = Math.min(sdCurrentPage * SD_PAGE_SIZE, totalRows);
    const total = totalRows;
    const loaded = rowsView.length;
    let text;
    if (total <= 0) {
      text = 'No stores';
    } else if (!sdStore.fullyLoaded && loaded < total) {
      text = `Showing ${startRow} to ${endRow} of ${total} stores (${loaded} loaded)`;
    } else {
      text = `Showing ${startRow} to ${endRow} of ${total} stores`;
    }
    document.querySelectorAll('.EzfyAllStores__pagination-text').forEach(el => {
      el.textContent = text;
    });
    const browseEl = document.getElementById('sd-browse-info');
    if (browseEl) browseEl.textContent = text;
  }

  function sdRenderPaginationBarBoth() {
    const rowsView = sdRowsForView();
    const totalRows = rowsView.length;
    const totalPages = Math.max(1, Math.ceil(totalRows / SD_PAGE_SIZE));
    const startRow = (sdCurrentPage - 1) * SD_PAGE_SIZE + 1;
    const endRow = Math.min(sdCurrentPage * SD_PAGE_SIZE, totalRows);
    const total = totalRows;
    const loaded = rowsView.length;
    let text;
    if (total <= 0) {
      text = 'No stores';
    } else if (!sdStore.fullyLoaded && loaded < total) {
      text = `Showing ${startRow} to ${endRow} of ${total} stores (${loaded} loaded)`;
    } else {
      text = `Showing ${startRow} to ${endRow} of ${total} stores`;
    }

    const controls = [];
    const prevDis = sdCurrentPage <= 1;
    controls.push(
      `<button type="button" class="EzfyAllStores__page-btn${prevDis ? ' EzfyAllStores__page-btn--disabled' : ''}" data-nav="prev" onclick="sdGoPrev()" ${prevDis ? 'disabled' : ''}>‹</button>`
    );

    const items = sdPaginationItems(totalPages, sdCurrentPage);
    items.forEach(item => {
      if (item === null) {
        controls.push('<span class="EzfyAllStores__page-dots" aria-hidden="true">...</span>');
      } else {
        const active = item === sdCurrentPage;
        const endR = Math.min(item * SD_PAGE_SIZE, totalRows);
        const available = rowsView.length >= endR;
        const skel = item > 1 && !available ? ' EzfyAllStores__page-btn--skeleton' : '';
        const activeCls = active ? ' EzfyAllStores__page-btn--active' : '';
        const dis = active || !available ? 'disabled' : '';
        controls.push(
          `<button type="button" data-page="${item}" class="EzfyAllStores__page-btn${activeCls}${skel}" onclick="sdRenderPage(${item})" ${dis}>${item}</button>`
        );
      }
    });

    const next = sdCurrentPage + 1;
    const nextDis =
      next > totalPages ||
      rowsView.length < Math.min(next * SD_PAGE_SIZE, totalRows);
    controls.push(
      `<button type="button" class="EzfyAllStores__page-btn${nextDis ? ' EzfyAllStores__page-btn--disabled' : ''}" data-nav="next" onclick="sdGoNext()" ${nextDis ? 'disabled' : ''}>›</button>`
    );

    const inner = `<div class="EzfyAllStores__pagination-text">${text}</div><div class="EzfyAllStores__pagination-controls">${controls.join('')}</div>`;
    const html = `<div class="EzfyAllStores__footer">${inner}</div>`;
    document.getElementById('sd-pagination-top').innerHTML = html;
    document.getElementById('sd-pagination').innerHTML = html;

    sdUpdatePaginationVisual();
  }

  function sdGoPrev() {
    if (sdCurrentPage > 1) sdRenderPage(sdCurrentPage - 1);
  }

  function sdGoNext() {
    const totalPages = Math.max(1, Math.ceil(sdRowsForView().length / SD_PAGE_SIZE));
    const next = sdCurrentPage + 1;
    if (next > totalPages) return;
    const endRow = Math.min(next * SD_PAGE_SIZE, sdStore.totalCount);
    if (sdStore.rows.length >= endRow) sdRenderPage(next);
  }

  function sdRenderPage(page) {
    if (page < 1) return;
    const rowsView = sdRowsForView();
    const totalPages = Math.max(1, Math.ceil(rowsView.length / SD_PAGE_SIZE));
    if (page > totalPages) return;

    if (page !== 1) sdLeftPage1Once = true;
    if (page === 1 && !sdLeftPage1Once) {
      sdCurrentPage = 1;
      sdRenderPaginationBarBoth();
      sdUpdateBrowsingInfo();
      return;
    }

    const startRow = (page - 1) * SD_PAGE_SIZE;
    const endRow = Math.min(page * SD_PAGE_SIZE, rowsView.length);
    const pageRows = rowsView.slice(startRow, endRow);

    if (!pageRows.length) {
      if (!rowsView.length) {
        const tbody = document.getElementById('sd-table-body');
        tbody.innerHTML = `<tr class="EzfyAllStores__tr"><td class="EzfyAllStores__td" colspan="${SD_VISIBLE_COLUMNS.length}">No stores match your filters.</td></tr>`;
        sdCurrentPage = 1;
        sdRenderPaginationBarBoth();
        sdUpdateBrowsingInfo();
        return;
      }
      sdRenderLoadingSkeleton();
      return;
    }

    const tbody = document.getElementById('sd-table-body');
    tbody.innerHTML = sdRenderRows(pageRows);

    sdCurrentPage = page;
    sdRenderPaginationBarBoth();
    sdUpdateBrowsingInfo();
    const sdScrollRoot = document.getElementById('ezfy-all-stores-directory');
    if (sdScrollRoot) sdScrollRoot.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function sdUpdateBrowsingInfo() {
    sdUpdatePaginationVisual();
  }

  function sdFillSelectOptions(selectId, values, placeholder) {
    const el = document.getElementById(selectId);
    if (!el) return;
    const current = el.value;
    const opts = Array.from(new Set(values.map(v => String(v || '').trim()).filter(Boolean))).sort((a, b) => a.localeCompare(b));
    el.innerHTML = `<option value="">${placeholder}</option>` + opts.map(v => `<option value="${v.replace(/"/g, '&quot;')}">${v}</option>`).join('');
    if (opts.includes(current)) el.value = current;
  }

  function sdHtmlEscape(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
  }

  function sdGetSubNicheOptionsForNiche(niche) {
    const nicheTrim = String(niche || '').trim();
    const rows = nicheTrim
      ? sdStore.rows.filter((r) => String(r.niche || '').trim() === nicheTrim)
      : sdStore.rows;
    return Array.from(new Set(rows.map((r) => String(r.sub_niche || '').trim()).filter(Boolean))).sort((a, b) => a.localeCompare(b));
  }

  function sdGetThemeOptions() {
    return Array.from(new Set(sdStore.rows.map((r) => String(r.theme || '').trim()).filter(Boolean))).sort((a, b) => a.localeCompare(b));
  }

  function sdRebuildSubNicheMulti() {
    const list = document.getElementById('sd-filter-subniche-list');
    if (!list) return;
    const opts = sdGetSubNicheOptionsForNiche(sdFilters.niche);
    sdFilters.subNiches = sdFilters.subNiches.filter((v) => opts.includes(v));
    if (!opts.length) {
      list.innerHTML = '<div class="EzfyAllStores__multi-empty">No sub-niches in this dataset yet.</div>';
    } else {
      list.innerHTML = opts
        .map((val, i) => {
          const id = `sd-subniche-cb-${i}`;
          const checked = sdFilters.subNiches.includes(val) ? ' checked' : '';
          return `<label class="EzfyAllStores__multi-option" for="${id}"><input type="checkbox" id="${id}" data-sd-multi-kind="subniche"${checked}><span>${sdHtmlEscape(val)}</span></label>`;
        })
        .join('');
      list.querySelectorAll('input[data-sd-multi-kind="subniche"]').forEach((input, i) => {
        input.value = opts[i];
      });
    }
    sdUpdateSubNicheToggleLabel();
  }

  function sdRebuildThemeMulti() {
    const list = document.getElementById('sd-filter-theme-list');
    if (!list) return;
    const opts = sdGetThemeOptions();
    sdFilters.themes = sdFilters.themes.filter((v) => opts.includes(v));
    if (!opts.length) {
      list.innerHTML = '<div class="EzfyAllStores__multi-empty">No themes in this dataset yet.</div>';
    } else {
      list.innerHTML = opts
        .map((val, i) => {
          const id = `sd-theme-cb-${i}`;
          const checked = sdFilters.themes.includes(val) ? ' checked' : '';
          return `<label class="EzfyAllStores__multi-option" for="${id}"><input type="checkbox" id="${id}" data-sd-multi-kind="theme"${checked}><span>${sdHtmlEscape(val)}</span></label>`;
        })
        .join('');
      list.querySelectorAll('input[data-sd-multi-kind="theme"]').forEach((input, i) => {
        input.value = opts[i];
      });
    }
    sdUpdateThemeToggleLabel();
  }

  function sdUpdateSubNicheToggleLabel() {
    const btn = document.getElementById('sd-filter-subniche-toggle');
    if (!btn) return;
    const n = sdFilters.subNiches.length;
    if (!n) {
      btn.textContent = sdFilters.niche ? 'All sub-niches (this niche)' : 'All sub niches';
    } else if (n === 1) {
      btn.textContent = sdFilters.subNiches[0];
    } else {
      btn.textContent = `${n} sub-niches selected`;
    }
  }

  function sdUpdateThemeToggleLabel() {
    const btn = document.getElementById('sd-filter-theme-toggle');
    if (!btn) return;
    const n = sdFilters.themes.length;
    if (!n) btn.textContent = 'All themes';
    else if (n === 1) btn.textContent = sdFilters.themes[0];
    else btn.textContent = `${n} themes selected`;
  }

  function sdCloseMultiPanels() {
    ['subniche', 'theme'].forEach((kind) => {
      const panel = document.getElementById(`sd-filter-${kind}-panel`);
      const toggle = document.getElementById(`sd-filter-${kind}-toggle`);
      if (panel) panel.hidden = true;
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  }

  function sdToggleMultiPanel(kind, forceOpen) {
    const panel = document.getElementById(`sd-filter-${kind}-panel`);
    const toggle = document.getElementById(`sd-filter-${kind}-toggle`);
    if (!panel || !toggle) return;
    const willOpen = forceOpen !== undefined ? forceOpen : panel.hidden;
    if (willOpen) {
      ['subniche', 'theme'].forEach((k) => {
        const p = document.getElementById(`sd-filter-${k}-panel`);
        const t = document.getElementById(`sd-filter-${k}-toggle`);
        const open = k === kind;
        if (p) p.hidden = !open;
        if (t) t.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    } else {
      panel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
    }
  }

  function sdRefreshFilterOptions() {
    sdFillSelectOptions('sd-filter-niche', sdStore.rows.map((r) => r.niche), 'All niches');
    sdRebuildSubNicheMulti();
    sdRebuildThemeMulti();
  }

  function sdApplyFilters() {
    const q = sdFilters.q.toLowerCase();
    const appsNeedle = sdFilters.apps.toLowerCase();
    sdFilteredRows = sdStore.rows.filter((row) => {
      if (sdFilters.niche && String(row.niche || '').trim() !== sdFilters.niche) return false;
      if (sdFilters.subNiches.length && !sdFilters.subNiches.includes(String(row.sub_niche || '').trim())) return false;
      const rowTheme = String(row.theme || '').trim();
      if (sdFilters.themes.length && !sdFilters.themes.includes(rowTheme)) return false;
      if (appsNeedle && !sdFormatApps(row.known_apps).toLowerCase().includes(appsNeedle)) return false;
      if (q) {
        const hay = [row.domain, row.theme, row.niche, row.sub_niche, sdFormatApps(row.known_apps)].map(v => String(v || '')).join(' ').toLowerCase();
        if (!hay.includes(q)) return false;
      }
      return true;
    });
    sdCurrentPage = 1;
    sdRenderPage(1);
  }

  function sdCountActiveFilters() {
    let n = 0;
    if (sdFilters.q.trim()) n += 1;
    if (sdFilters.niche.trim()) n += 1;
    if (sdFilters.subNiches.length) n += 1;
    if (sdFilters.themes.length) n += 1;
    if (sdFilters.apps.trim()) n += 1;
    return n;
  }

  function sdUpdateFilterBadges() {
    const n = sdCountActiveFilters();
    const badge = document.getElementById('sd-filter-badge');
    const fabBadge = document.getElementById('sd-filter-fab-badge');
    const toggle = document.getElementById('sd-filter-toggle');
    [badge, fabBadge].forEach(el => {
      if (!el) return;
      el.textContent = n;
      el.hidden = n === 0;
    });
    if (toggle) toggle.classList.toggle('EzfyAllStores__filter-toggle--active', n > 0);
  }

  function sdUpdateFilterResultCount() {
    const el = document.getElementById('sd-filter-result-count');
    if (!el) return;
    const n = sdCountActiveFilters();
    if (!n) { el.textContent = ''; return; }
    const total = sdRowsForView().length;
    el.textContent = `${total.toLocaleString()} store${total !== 1 ? 's' : ''} match`;
  }

  function sdOpenFilterModal() {
    const m = document.getElementById('sd-filter-modal');
    if (!m) return;
    m.classList.add('EzfyAllStores__popup-overlay--active');
    m.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(() => {
      const first = m.querySelector('input, select');
      if (first) first.focus();
    }, 50);
  }

  function sdCloseFilterModal() {
    sdCloseMultiPanels();
    const m = document.getElementById('sd-filter-modal');
    if (!m) return;
    m.classList.remove('EzfyAllStores__popup-overlay--active');
    m.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function sdInitFilters() {
    // open from header button
    const toggle = document.getElementById('sd-filter-toggle');
    if (toggle) toggle.addEventListener('click', sdOpenFilterModal);

    // open from sticky FAB
    const fab = document.getElementById('sd-filter-fab');
    if (fab) fab.addEventListener('click', sdOpenFilterModal);

    // close button inside modal
    const closeBtn = document.getElementById('sd-filter-close');
    if (closeBtn) closeBtn.addEventListener('click', sdCloseFilterModal);

    // backdrop click
    const modal = document.getElementById('sd-filter-modal');
    if (modal) {
      modal.addEventListener('click', (e) => {
        if (e.target === modal) sdCloseFilterModal();
      });
    }

    // apply button
    const applyBtn = document.getElementById('sd-filter-apply');
    if (applyBtn) applyBtn.addEventListener('click', sdCloseFilterModal);

    // sticky FAB visibility on scroll
    const headerEl = document.querySelector('.EzfyAllStores__header');
    if (fab && headerEl) {
      const obs = new IntersectionObserver(
        ([entry]) => {
          fab.hidden = false;
          fab.classList.toggle('EzfyAllStores__filter-fab--visible', !entry.isIntersecting);
        },
        { threshold: 0 }
      );
      obs.observe(headerEl);
    }

    const simpleMap = [
      ['sd-filter-q', 'q'],
      ['sd-filter-apps', 'apps']
    ];
    simpleMap.forEach(([id, key]) => {
      const el = document.getElementById(id);
      if (!el) return;
      el.addEventListener('input', () => {
        sdFilters[key] = el.value.trim();
        sdApplyFilters();
        sdUpdateFilterBadges();
        sdUpdateFilterResultCount();
      });
    });

    const nicheEl = document.getElementById('sd-filter-niche');
    if (nicheEl) {
      nicheEl.addEventListener('change', () => {
        sdFilters.niche = nicheEl.value.trim();
        sdRebuildSubNicheMulti();
        sdApplyFilters();
        sdUpdateFilterBadges();
        sdUpdateFilterResultCount();
      });
    }

    const subList = document.getElementById('sd-filter-subniche-list');
    if (subList) {
      subList.addEventListener('change', (e) => {
        const t = e.target;
        if (!t.matches('input[type="checkbox"][data-sd-multi-kind="subniche"]')) return;
        const val = String(t.value || '').trim();
        if (t.checked) {
          if (!sdFilters.subNiches.includes(val)) sdFilters.subNiches.push(val);
        } else {
          sdFilters.subNiches = sdFilters.subNiches.filter((x) => x !== val);
        }
        sdUpdateSubNicheToggleLabel();
        sdApplyFilters();
        sdUpdateFilterBadges();
        sdUpdateFilterResultCount();
      });
    }

    const themeList = document.getElementById('sd-filter-theme-list');
    if (themeList) {
      themeList.addEventListener('change', (e) => {
        const t = e.target;
        if (!t.matches('input[type="checkbox"][data-sd-multi-kind="theme"]')) return;
        const val = String(t.value || '').trim();
        if (t.checked) {
          if (!sdFilters.themes.includes(val)) sdFilters.themes.push(val);
        } else {
          sdFilters.themes = sdFilters.themes.filter((x) => x !== val);
        }
        sdUpdateThemeToggleLabel();
        sdApplyFilters();
        sdUpdateFilterBadges();
        sdUpdateFilterResultCount();
      });
    }

    const subToggle = document.getElementById('sd-filter-subniche-toggle');
    if (subToggle) {
      subToggle.addEventListener('click', (e) => {
        e.stopPropagation();
        const panel = document.getElementById('sd-filter-subniche-panel');
        sdToggleMultiPanel('subniche', panel ? panel.hidden : false);
      });
    }
    const themeToggle = document.getElementById('sd-filter-theme-toggle');
    if (themeToggle) {
      themeToggle.addEventListener('click', (e) => {
        e.stopPropagation();
        const panel = document.getElementById('sd-filter-theme-panel');
        sdToggleMultiPanel('theme', panel ? panel.hidden : false);
      });
    }

    document.addEventListener('click', (e) => {
      if (!e.target.closest('.EzfyAllStores__multi-wrap')) sdCloseMultiPanels();
    });

    const clearBtn = document.getElementById('sd-filter-clear');
    if (clearBtn) {
      clearBtn.addEventListener('click', () => {
        sdFilters.q = '';
        sdFilters.niche = '';
        sdFilters.subNiches = [];
        sdFilters.themes = [];
        sdFilters.apps = '';
        simpleMap.forEach(([id]) => {
          const el = document.getElementById(id);
          if (el) el.value = '';
        });
        const ne = document.getElementById('sd-filter-niche');
        if (ne) ne.value = '';
        sdRebuildSubNicheMulti();
        sdRebuildThemeMulti();
        sdCloseMultiPanels();
        sdApplyFilters();
        sdUpdateFilterBadges();
        sdUpdateFilterResultCount();
      });
    }
  }

  async function sdFetchAllChunks() {
    const selectCols = SD_SELECT_COLUMNS.join(',');
    let offset = SD_PAGE_SIZE;

    while (true) {
      const res = await fetch(
        `${SD_SUPABASE_URL}/rest/v1/stores?select=${selectCols}&order=domain.asc.nullslast&limit=${SD_FETCH_CHUNK_SIZE}&offset=${offset}`,
        {
          headers: {
            apikey: SD_SUPABASE_ANON,
            Authorization: `Bearer ${SD_SUPABASE_ANON}`
          }
        }
      );

      if (!res.ok) {
        console.warn(`Chunk fetch failed at offset ${offset}, retrying...`);
        await sdSleep(SD_RETRY_DELAY_MS);
        continue;
      }

      const chunk = await res.json();

      if (!Array.isArray(chunk) || chunk.length === 0) break;

      sdStore.rows = sdStore.rows.concat(chunk);
      offset += chunk.length;

      sdUnlockPaginationButtons();
      sdUpdateBrowsingInfo();

      if (chunk.length < SD_FETCH_CHUNK_SIZE) break;
    }

    sdStore.fullyLoaded = true;
    await sdTryStoreCache();
    sdRefreshFilterOptions();
    sdUnlockPaginationButtons();
    sdUpdateBrowsingInfo();
  }

  function sdOpenTrafficModal(ev) {
    if (ev) ev.preventDefault();
    const m = document.getElementById('sd-traffic-modal');
    if (!m) return;
    m.classList.add('EzfyAllStores__popup-overlay--active');
    m.setAttribute('aria-hidden', 'false');
  }

  function sdCloseTrafficModal() {
    const m = document.getElementById('sd-traffic-modal');
    if (!m) return;
    m.classList.remove('EzfyAllStores__popup-overlay--active');
    m.setAttribute('aria-hidden', 'true');
  }

  function sdOpenSuccessModal() {
    const m = document.getElementById('sd-success-modal');
    if (!m) return;
    m.classList.add('EzfyAllStores__popup-overlay--active');
    m.setAttribute('aria-hidden', 'false');
  }

  function sdCloseSuccessModal() {
    const m = document.getElementById('sd-success-modal');
    if (!m) return;
    m.classList.remove('EzfyAllStores__popup-overlay--active');
    m.setAttribute('aria-hidden', 'true');
  }

  function sdFormatTheme(value) {
    if (value === null || value === undefined || value === '') return '-';
    const str = String(value).trim();
    if (!str) return '-';
    const match = sdThemesByName[sdNormalizeThemeName(str)];
    if (!match || sdNormalizeThemeName(match.title) !== sdNormalizeThemeName(str)) return str;
    const themeUrl = sdAppendThemeUtm(match.themeUrl);
    return `<a href="${themeUrl}" target="_blank" rel="noopener">${str}</a>`;
  }

  function sdFormatAppsWithLinks(value) {
    const appTitles = sdSplitApps(value);
    if (!appTitles.length) return '-';

    const rendered = appTitles.map(title => {
      const link = sdAppsByTitle[sdNormalizeThemeName(title)];
      if (!link) return title;
      return `<a href="${link}" target="_blank" rel="noopener">${title}</a>`;
    });

    return rendered.join(', ');
  }


  function sdStripProtocol(value) {
    return String(value ?? '').replace(/^https?:[/][/]/i, '');
  }

  function sdFormatWebsiteCell(domainVal, currencyVal) {
    const domainRaw = String(domainVal ?? '').trim();
    if (!domainRaw || domainRaw === '-') return '<td class="EzfyAllStores__td" data-sd-value="">-</td>';
    const href = domainRaw.startsWith('http://') || domainRaw.startsWith('https://') ? domainRaw : `https://${domainRaw}`;
    const display = sdStripProtocol(domainRaw);
    const esc = display.replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;');
    const code = String(currencyVal ?? '').trim().toUpperCase();
    const cc = sdCurrencyCountry(code);
    const flag = cc
      ? `<img class="EzfyAllStores__flag" src="https://flagcdn.com/${cc}.svg" alt="${code} flag" loading="lazy" width="20" height="14">`
      : '<span class="EzfyAllStores__flag EzfyAllStores__flag--fallback" aria-hidden="true">&#127987;</span>';
    return `<td class="EzfyAllStores__td" data-sd-value="${esc}"><a class="EzfyAllStores__url-link" href="${href}" target="_blank" rel="noopener">${esc}</a><span class="EzfyAllStores__currency EzfyAllStores__currency--inline">(${flag}${code})</span></td>`;
  }

  function sdFormatAppsCell(value, totalApps) {
    const appTitles = sdSplitApps(value);
    if (!appTitles.length) return '<td class="EzfyAllStores__td EzfyAllStores__td--apps" title="0 apps">-</td>';
    const rendered = appTitles.map((title) => {
      const safe = String(title).replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;');
      return safe;
    }).join(', ');
    return `<td class="EzfyAllStores__td EzfyAllStores__td--apps" title="${totalApps} apps"><span class="EzfyAllStores__apps-text">${rendered}</span></td>`;
  }

  function sdFormatMobileScore(val) {
    const score = parseFloat(val);
    if (isNaN(score)) {
      return `<td class="EzfyAllStores__td"><span class="EzfyAllStores__score EzfyAllStores__score--na">${val}</span></td>`;
    }
    const tier = score >= 90 ? 'good' : score >= 50 ? 'warn' : 'bad';
    return `<td class="EzfyAllStores__td"><span class="EzfyAllStores__score EzfyAllStores__score--${tier}">${val}</span></td>`;
  }

  function sdThemeIconLetter(str) {
    const s = String(str || '').trim();
    if (!s || s === '-') return '?';
    const ch = s[0];
    return /[a-zA-Z0-9]/.test(ch) ? ch.toUpperCase() : '?';
  }

  function sdThemeIconColor(str) {
    const PALETTE = ['#5a4bdf','#3b429f','#10b981','#1e293b','#be185d','#ea580c','#0891b2','#7c3aed','#111827','#0f766e'];
    let h = 0;
    const s = String(str || '');
    for (let i = 0; i < s.length; i += 1) h = ((h << 5) - h) + s.charCodeAt(i) | 0;
    return PALETTE[Math.abs(h) % PALETTE.length];
  }

  function sdFaviconSrc(url, size = 32) {
    const raw = String(url ?? '').trim();
    if (!raw || raw === '-') return '';
    let host = raw;
    if (host.startsWith('http://') || host.startsWith('https://')) host = host.split('://')[1] || '';
    host = host.split('/')[0].trim();
    if (!host) return '';
    return `https://www.google.com/s2/favicons?domain=${encodeURIComponent(host)}&sz=${size}`;
  }

  function sdFormatThemeCell(val, storeUrl) {
    const str = String(val ?? '').trim();
    if (!str || str === '-') {
      return `<td class="EzfyAllStores__td EzfyAllStores__td--theme" data-sd-value="-"><div class="EzfyAllStores__theme-cell"><div class="EzfyAllStores__theme-icon" style="background-color:#94a3b8;">?</div><div class="EzfyAllStores__theme-text"><span class="EzfyAllStores__theme-name">-</span><small class="EzfyAllStores__theme-hint"><a class="EzfyAllStores__theme-hint-link" href="${SD_CHROME_EXTENSION_URL}" target="_blank" rel="noopener">Use our chrome extension to fetch data from any store</a></small></div></div></td>`;
    }
    const inner = sdFormatTheme(val);
    const letter = sdThemeIconLetter(str);
    const color = sdThemeIconColor(str);
    const esc = str.replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;');
    const favicon = sdFaviconSrc(storeUrl, 32);
    const iconHtml = favicon
      ? `<img class="EzfyAllStores__theme-favicon" src="${favicon}" alt="${esc} favicon" loading="lazy" width="32" height="32" onerror="this.style.display='none';this.nextElementSibling.style.display='flex';"><div class="EzfyAllStores__theme-icon EzfyAllStores__theme-icon--fallback" style="display:none;background-color:${color};">${letter}</div>`
      : `<div class="EzfyAllStores__theme-icon" style="background-color:${color};">${letter}</div>`;
    return `<td class="EzfyAllStores__td EzfyAllStores__td--theme" data-sd-value="${esc}"><div class="EzfyAllStores__theme-cell">${iconHtml}<div class="EzfyAllStores__theme-text"><span class="EzfyAllStores__theme-name">${inner}</span><small class="EzfyAllStores__theme-hint"><a class="EzfyAllStores__theme-hint-link" href="${SD_CHROME_EXTENSION_URL}" target="_blank" rel="noopener">Use our chrome extension to fetch data from any store</a></small></div></div></td>`;
  }

  function sdFormatUrlCell(val) {
    const str = String(val ?? '').trim();
    if (!str || str === '-') return '<td class="EzfyAllStores__td" data-sd-value="">-</td>';
    const href = str.startsWith('http://') || str.startsWith('https://') ? str : `https://$<class 'str'>`;
    const esc = str.replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;');
    return `<td class="EzfyAllStores__td EzfyAllStores__td--website" data-sd-value="${esc}"><a class="EzfyAllStores__url-link" href="${href}" target="_blank" rel="noopener">${esc}</a></td>`;
  }

  function sdCurrencyCountry(code) {
    const map = {USD:'us',CAD:'ca',GBP:'gb',EUR:'eu',AUD:'au',NZD:'nz',JPY:'jp',CNY:'cn',HKD:'hk',SGD:'sg',INR:'in',BRL:'br',MXN:'mx',CHF:'ch',SEK:'se',NOK:'no',DKK:'dk',ZAR:'za'};
    return map[String(code || '').trim().toUpperCase()] || '';
  }

  function sdFormatCurrencyCell(val) {
    const code = String(val ?? '').trim().toUpperCase();
    if (!code || code === '-') return '<td class="EzfyAllStores__td">-</td>';
    const cc = sdCurrencyCountry(code);
    const img = cc
      ? `<img class="EzfyAllStores__flag" src="https://flagcdn.com/${cc}.svg" alt="${code} flag" loading="lazy" width="20" height="14">`
      : '<span class="EzfyAllStores__flag EzfyAllStores__flag--fallback" aria-hidden="true">🏳️</span>';
    return `<td class="EzfyAllStores__td"><span class="EzfyAllStores__currency">${img}<span>${code}</span></span></td>`;
  }

  function sdFormatLcp(value) {
    if (value === null || value === undefined || value === '-' || value === '') return '-';
    const n = parseFloat(String(value).replace(/,/g, ''));
    if (!Number.isFinite(n) || n <= 0) return String(value);
    if (n < 500) return Number.isInteger(n) ? `${n}s` : `${n.toFixed(1)}s`;
    return String(value);
  }

  function sdRenderRows(stores) {
    return stores.map(s => {
      const cells = SD_VISIBLE_COLUMNS.map(key => {
        const val = s[key] ?? '-';
        if (key === 'theme') {
          return sdFormatThemeCell(val, s.domain);
        }
        if (key === 'domain') {
          return sdFormatUrlCell(val);
        }
        if (key === 'currency') {
          return sdFormatCurrencyCell(val);
        }
        if (key === 'known_apps') {
          const db = s.total_apps;
          const n = (db !== null && db !== undefined && db !== '' && db !== '-') ? db : sdSplitApps(s.known_apps).length;
          return sdFormatAppsCell(val, n);
        }
        if (key === 'blog_url') {
          const raw = String(val ?? '').trim();
          const has = raw && raw !== '-' && raw.toLowerCase() !== 'null' && raw.toLowerCase() !== 'none';
          if (has) {
            const esc = raw.replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;');
            return `<td class="EzfyAllStores__td" data-sd-value="${esc}"><span class="EzfyAllStores__icon-check" aria-label="Has blog">✓</span></td>`;
          }
          return '<td class="EzfyAllStores__td" data-sd-value=""><span class="EzfyAllStores__icon-cross" aria-label="No blog">✕</span></td>';
        }
        if (key === 'mobile_score_home' || key === 'mobile_score_product') {
          const cls = key === 'mobile_score_home' ? 'EzfyAllStores__td--score-home' : 'EzfyAllStores__td--score-product';
          return sdFormatMobileScore(val).replace('EzfyAllStores__td"', `EzfyAllStores__td ${cls}"`);
        }
        if (key === 'estimated_visits_and_income') {
          return '<td class="EzfyAllStores__td" data-sd-value=""><button type="button" class="EzfyAllStores__action-btn sd-traffic-link">Traffic & Value</button></td>';
        }
        return `<td class="EzfyAllStores__td">${val}</td>`;
      }).join('');
      return `<tr class="EzfyAllStores__tr">${cells}</tr>`;
    }).join('\n');
  }

  function sdRenderLoadingSkeleton() {
    const tbody = document.getElementById('sd-table-body');
    if (!tbody) return;
    const rowCount = 10;
    const rows = Array.from({ length: rowCount }, () => `
      <tr class="EzfyAllStores__tr">
        ${SD_VISIBLE_COLUMNS.map(() => '<td class="EzfyAllStores__td"><span class="sd-skeleton-line"></span></td>').join('')}
      </tr>
    `).join('');
    tbody.innerHTML = rows;
  }

  (async () => {
    try {
      await Promise.all([sdFetchThemes(), sdFetchApps()]);
    } catch (error) {
      console.warn('Could not preload metadata', error);
    }

    sdParseStaticRows();
    sdCurrentRowsView = sdStore.rows;
    let usedLocalCache = false;
    try {
      const idbCache = await sdReadIdbCache();
      const localCacheRaw = localStorage.getItem(SD_CACHE_KEY);
      const localCache = localCacheRaw ? JSON.parse(localCacheRaw) : null;
      const cache = idbCache && Array.isArray(idbCache.rows) ? idbCache : localCache;
      if (cache && Array.isArray(cache.rows) && cache.rows.length) {
        sdStore.rows = cache.rows;
        sdStore.totalCount = cache.totalCount || cache.rows.length;
        sdStore.fullyLoaded = true;
        usedLocalCache = true;
      }
    } catch (e) {
      console.warn('Local cache read failed', e);
    }

    if (!usedLocalCache) {
      try {
        await sdFetchTotalCountWithRetry();
      } catch (error) {
        const wrap = document.getElementById('sd-table-wrap');
        wrap.innerHTML = '<p>Error loading store count. Please try again.</p>';
        console.error(error);
        return;
      }
    }

    sdRenderPaginationBarBoth();
    sdUpdateBrowsingInfo();
    sdRefreshFilterOptions();
    sdInitFilters();

    if (!usedLocalCache) {
      sdFetchAllChunks().catch(err => console.error('Chunk loading failed:', err));
    }

    const sdTableWrap = document.getElementById('sd-table-wrap');
    if (sdTableWrap) {
      sdTableWrap.addEventListener('click', (e) => {
        if (e.target.closest('.sd-traffic-link')) {
          e.preventDefault();
          sdOpenTrafficModal(e);
        }
      });
    }
    const sdTrafficModal = document.getElementById('sd-traffic-modal');
    if (sdTrafficModal) {
      sdTrafficModal.addEventListener('click', (e) => {
        if (e.target === sdTrafficModal) sdCloseTrafficModal();
      });
    }
    document.querySelectorAll('[data-sd-close-modal]').forEach((el) => {
      el.addEventListener('click', () => sdCloseTrafficModal());
    });
    const sdSuccessModal = document.getElementById('sd-success-modal');
    if (sdSuccessModal) {
      sdSuccessModal.addEventListener('click', (e) => {
        if (e.target === sdSuccessModal) sdCloseSuccessModal();
      });
    }
    document.querySelectorAll('[data-sd-close-success-modal]').forEach((el) => {
      el.addEventListener('click', () => sdCloseSuccessModal());
    });
    const qs = new URLSearchParams(window.location.search);
    if (qs.get('customer_posted') === 'true' && window.location.hash === '#sd-traffic-waitlist') {
      sdOpenSuccessModal();
      if (window.history && window.history.replaceState) {
        window.history.replaceState({}, document.title, window.location.pathname + window.location.hash);
      }
    }
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        sdCloseTrafficModal();
        sdCloseSuccessModal();
        sdCloseFilterModal();
      }
    });
  })();
